module.exports = __webpack_public_path__ + "img/wizard-icon-add.19d6bc68.png";